<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonService.showTour">
    <main class="page-content">
        <div class="bgColor">



            <div class="card">
                <div class="card-header">
                    Course Update payment
                </div>
                <div class="card-body">
                    <table class="table table-responsive table-stripped">
                        <thead>
                            <th>Amount 3</th>
                            <th>Amount 4</th>
                            <th>Validity</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let p of payment">
                                <ng-container *ngIf="p.edit then edit else show ">


                                </ng-container>

                                <ng-template #show>
                                    <td>{{p?.amount_1}}</td>
                                    <td>{{p?.amount_2}}</td>
                                    <td>{{p?.valdity_days}}</td>
                                    <td>
                                        <button class="btn btn-success" (click)="p.edit = true">Update</button>
                                    </td>
                                </ng-template>
                                <ng-template #edit>
                                    <td>
                                        <input type="number" class="form-control form-control-sm" value="{{p?.amount_1}}" [(ngModel)]="p.amount_1">

                                    </td>
                                    <td> <input type="number" class="form-control form-control-sm" value="{{p?.amount_2}}" [(ngModel)]="p.amount_2"> </td>
                                    <td> <input type="number" class="form-control form-control-sm" value="{{p?.valdity_days}}" [(ngModel)]="p.valdity_days"> </td>

                                    <td>
                                        <button class="btn btn-success" (click)="updatePaymentSettings(p);p.edit = false">Save</button>
                                        <button class="btn btn-danger ml-1" (click)="getCoursePaymentSettings();p.edit = false">Cancel</button>

                                    </td>
                                </ng-template>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>



            <div class="card">
                <div class="card-header">
                    Course Payment Details
                </div>
                <div class="card-body">
                    <div>
                        <div class="row">
                            <div class="col-sm-4">
                                <input type="text" placeholder="Enter user mobile number" class="form-control form-control-sm" id="search" [(ngModel)]="search.user_contactnumber">
                            </div>

                            <div class="col-sm-4">
                                <button class="btn btn-success" (click)="getPaymentDetails()"> Filter </button>
                            </div>
                        </div>


                    </div>
                    <div class="tableView">
                        <div class="table-responsive">
                            <table class="table   ">
                                <thead>
                                    <th *ngFor="let c of tableColums">{{c}}</th>
                                    <!-- <th>Action</th> -->
                                </thead>
                                <tbody *ngIf="payment[0].type_id == 2">
                                    <tr *ngFor="let p of payment[0].payment_details">
                                        <td *ngFor="let c of tableColums">{{p[c]}}</td>
                                        <!-- <td> <i class="fa fa-download" *ngIf="p.payment_status == 'Success'" (click)="downloadInvoice(p)" aria-hidden="true" style="color:  #8686f1;"></i></td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>



                </div>
            </div>
        </div>

        <!-- <div class="backdrop" [ngStyle]="{'display':display}"></div> -->
        <!-- <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">

        </div> -->
    </main>

</div>